import {Component, Input, OnInit} from '@angular/core';
import {ControlContainer, FormBuilder} from "@angular/forms";
import {lastValueFrom, switchMap} from "rxjs";

import Swal from "sweetalert2";

import {MasterService, ProcedureService} from "@services";

/**
 * Componente hijo para el formulario de campos de acción en la validación del funcionario
 */
@Component({
  selector: 'app-fields-action',
  templateUrl: './fields-action.component.html',
  styleUrls: ['./fields-action.component.scss'],
})
export class FieldsActionComponent implements OnInit {

  @Input() isLegalPerson: boolean;
  @Input() tramiteObject: any;
  @Input() onlyReadFieldsActions: boolean;

  /**
   * Formulario hijo para guardar los campos de acción en el formulario padre
   */
  public fieldsActionForm;

  /**
   * Cadena para conectar al formulario padre y guardar los campos de acción en la opción de persona natural o juridica
   */
  public cadenaFormPadre: string;

  /**
   * Centinela para cambiar la vista a solo visualización de los campos de acción
   */
  public soloLecturaCamposAccion: boolean = false;

  /**
   * Lista de perfiles que puede seleccionar la persona natural
   */
  public listaPerfilesNaturalPerson: any = [];

  /**
   * Lista de campos de acción que puede seleccionar la persona juridica
   */
  public listCamposDeAccionLegalPerson: any = [];

  /**
   * Lista dinamica para guarda los campos de acción
   */
  public relationProfilesFieldsOfAction: any = [];


  constructor(private procedureService: ProcedureService,
              public fb: FormBuilder,
              private controlContainer: ControlContainer,
              private masterService: MasterService) {}

  /**
   * Valida que estado tiene la solicitud para así cambiar el formato de visualizacion de los campos de acción
   */
  ngOnInit(): void {
    this.fieldsActionForm = this.controlContainer.control;
    this.fieldsActionForm = this.fieldsActionForm.controls['fieldsActionForm'];
    this.cadenaFormPadre = this.isLegalPerson ? 'relationAddressFieldsOfAction' : 'relationProfilesFieldsOfAction';

    if (this.tramiteObject.statusId == 7 || this.tramiteObject.statusId == 10 || this.onlyReadFieldsActions) { //Subdirector a pintar
      this.pintarCamposAccion();
    } else {
      this.getList();
      if (this.tramiteObject.statusId == 1 || this.tramiteObject.statusId == 5 || this.tramiteObject.statusId == 8) { //Validador a guardar
        this.add();
      } else if (this.tramiteObject.statusId == 2 || this.tramiteObject.statusId == 3) { // Coordinador a editar
        this.convertirTextoConIdsCamposDeAccionParaCoordinador().then(resp => {
          this.relationProfilesFieldsOfAction = resp;
          this.guardarPerfiles(false);
        });
      }
    }
  }

  /**
   * Agrega un nuevo objeto vacio a la lista para un nuevo campo de acción
   */
  public add(): void {
    this.relationProfilesFieldsOfAction.push({
      "address": null,
      "idProfil": null,
      "idfieldsOfAction": [],
      "fieldsAction": []
    })
  }

  /**
   * Elimina un objeto de la lista quitando un campo de acción
   */
  public remove(): void {
    if (this.relationProfilesFieldsOfAction.length == 1) {
      Swal.fire({
        icon: 'error',
        title: 'Acción no permitida',
        text: 'Debe existir al menos una relación de campos de acción'
      });
    } else {
      this.relationProfilesFieldsOfAction.pop();
    }
  }

  /**
   * Guarda los campos de acción escogidos
   */
  public guardarPerfiles(showPopUp: boolean): void {

    let listFieldsAction = JSON.parse(JSON.stringify(this.relationProfilesFieldsOfAction));

    for (const element of listFieldsAction) {

      if (element.idProfil == null && !this.isLegalPerson) {
        Swal.fire({
          icon: 'error',
          title: 'Acción no permitida',
          text: 'No se han definido los perfiles para la solicitud'
        });
        return;
      }

      if ((element.address == '' || element.address == null) && this.isLegalPerson) {
        Swal.fire({
          icon: 'error',
          title: 'Acción no permitida',
          text: 'No se han definido las direcciones o sedes para la solicitud'
        });
        return;
      }

      if (!this.isLegalPerson && listFieldsAction.length > 1 && this.yaExistePerfil(listFieldsAction)) {
        Swal.fire({
          icon: 'error',
          title: 'Acción no permitida',
          text: 'No pueden existir perfiles duplicados, asegurese que está escogiendo perfiles distintos.'
        });
        return;
      }

      if (element.idfieldsOfAction.length == 0) {
        Swal.fire({
          icon: 'error',
          title: 'Acción no permitida',
          text: 'No se han definido los campos de acción para la solicitud'
        });
        return;
      }

      this.isLegalPerson ? delete element.idProfil : delete element.address
      delete element.fieldsAction;
      this.showpopupmessage(showPopUp,listFieldsAction);
    }



  }
  public showpopupmessage(showPopUp: boolean,listFieldsAction:any): void
  {
    this.fieldsActionForm.get(this.cadenaFormPadre).setValue(listFieldsAction);

    if (showPopUp) {
      Swal.fire(
        {
          icon: 'success',
          title: 'Guardado',
          text: 'Se han guardado la relación con campos de acción para la solicitud'
        }
      );
    }
  }

  /**
   * Verifica si ya existe un perfil escogido
   * @param arrayVerificar Array a verificar si contiene un perfil duplicado
   * @return True si hay al menos un perfil repetido, false de lo contrario
   */
  private yaExistePerfil(arrayVerificar): boolean {

    for (let i = 0; i < arrayVerificar.length; i++) {
      let perfilActual = arrayVerificar[i].idProfil;

      for (let j = i + 1; j < arrayVerificar.length; j++) {
        let perfilComparado = arrayVerificar[j].idProfil;

        if (perfilActual == perfilComparado) {
          return true;
        }
      }
    }
    return false;
  }


  /**
   * Carga las listas desplegables de los campos de accion
   */
  private getList(): void {
    if (this.isLegalPerson) {
      this.masterService.getFieldsOfActionByPersonType(2).subscribe(resp => this.listCamposDeAccionLegalPerson = resp);
    } else {
      this.masterService.getProfiles().subscribe(resp => this.listaPerfilesNaturalPerson = resp);
    }
  }

  /**
   * Carga los campos de acción de persona natural dado un perfil escogido
   * @param item Perfil escogido
   */
  public getFieldsOfActionByProfile(item): void {
    this.masterService.getFieldsOfActionByProfile(item.idProfil).subscribe(resp => item.fieldsAction = resp);
  }

  /**
   * Pinta los campos de acción deshabilitados para mostrar al subdirector
   */
  private pintarCamposAccion(): void {
    this.soloLecturaCamposAccion = true;
    this.relationProfilesFieldsOfAction = this.fieldsActionForm.get(this.cadenaFormPadre).value;
  }

  /**
   * Convierte los campos de acción al formato del componente para su edicción en el rol coordinador
   */
  private async convertirTextoConIdsCamposDeAccionParaCoordinador(): Promise<any> {
    let camposDeAccionConvertidos: any[] = [];
    let listadoAllCamposDeAccion: any[] = [];
    let listadoAllPerfiles: any[] = [];
    let actionFieldsActuales = this.fieldsActionForm.get(this.cadenaFormPadre).value;

    await lastValueFrom(this.masterService.getFieldsOfActionByPersonType(this.isLegalPerson ? 2 : 1).pipe(
      switchMap(resp1 => {
        listadoAllCamposDeAccion = resp1;
        return this.masterService.getProfiles();
      })
    )).then(async resp2 => {
      listadoAllPerfiles = resp2;

      for (const actionFieldActual of actionFieldsActuales) {

        let address: string = null;
        let idProfil: number = 0;
        let idfieldsOfAction: any[] = [];
        let fieldsAction: any[] = [];

        if (this.isLegalPerson) {
          address = actionFieldActual.description;
        } else {
          idProfil = listadoAllPerfiles.find(perfil => perfil.description == actionFieldActual.description).id;
        }

        for (const actionFieldActualElement of actionFieldActual.fieldsOfActions) {
          idfieldsOfAction.push(listadoAllCamposDeAccion.find(campo => campo.description == actionFieldActualElement).id);
          await lastValueFrom(this.masterService.getFieldsOfActionByProfile(idProfil)).then(resp => fieldsAction = resp);
        }

        camposDeAccionConvertidos.push({
          "address": address,
          "idProfil": idProfil,
          "idfieldsOfAction": idfieldsOfAction,
          "fieldsAction": fieldsAction
        })
      }
    });
    return camposDeAccionConvertidos;
  }

}
